export const STATUS_FLOW = ["recebido", "aceito", "preparando", "saiu_entrega", "entregue"];

export const STATUS_META = {
  recebido: { label: "Recebido", color: "#F57C00", desc: "Pedido recebido, aguardando confirmação." },
  aceito: { label: "Aceito", color: "#1976D2", desc: "Atendente aceitou o pedido." },
  preparando: { label: "Preparando", color: "#7B1FA2", desc: "Seu pedido está na cozinha." },
  saiu_entrega: { label: "Saiu para entrega", color: "#0097A7", desc: "O entregador está a caminho." },
  entregue: { label: "Entregue", color: "#2E7D32", desc: "Pedido entregue. Bom apetite!" },
  cancelado: { label: "Cancelado", color: "#C62828", desc: "Pedido cancelado." },
};

export const nextStatus = (s) => {
  const i = STATUS_FLOW.indexOf(s);
  if (i === -1 || i === STATUS_FLOW.length - 1) return null;
  return STATUS_FLOW[i + 1];
};

export const nextStatusLabel = {
  recebido: "Aceitar pedido",
  aceito: "Enviar p/ cozinha",
  preparando: "Saiu para entrega",
  saiu_entrega: "Marcar entregue",
};
